import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, fmt } from '../api';

const TABS = ['all', 'meta', 'pinterest', 'reddit'] as const;

export default function Campaigns() {
  const [tab, setTab] = useState<(typeof TABS)[number]>('all');
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setLoading(true);
    api
      .campaigns(tab === 'all' ? undefined : tab)
      .then(setRows)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refresh();
  }, [tab]);

  async function pause(id: string) {
    await api.pauseCampaign(id);
    refresh();
  }
  async function resume(id: string) {
    await api.resumeCampaign(id);
    refresh();
  }

  return (
    <>
      <h2 className="page-title">Campaigns</h2>
      <p className="page-sub">Multi-platform campaign manager</p>

      <div style={{ marginBottom: 16, display: 'flex', gap: 6 }}>
        {TABS.map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`btn btn-small ${tab === t ? 'btn-primary' : ''}`}
            style={{ textTransform: 'capitalize' }}
          >
            {t}
          </button>
        ))}
        <div style={{ flex: 1 }} />
        <Link to="/campaigns/new" className="btn btn-primary btn-small">
          + New campaign
        </Link>
      </div>

      <div className="card">
        {loading ? (
          <div className="empty">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="empty">
            No campaigns yet.{' '}
            <Link to="/campaigns/new">Launch your first →</Link>
          </div>
        ) : (
          <table className="data">
            <thead>
              <tr>
                <th>Campaign</th>
                <th>Product</th>
                <th>Status</th>
                <th className="num">Daily budget</th>
                <th className="num">Spend (7d)</th>
                <th className="num">Revenue (7d)</th>
                <th className="num">ROAS</th>
                <th className="num">CTR</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((c: any) => (
                <tr key={c.id}>
                  <td>
                    <Link to={`/campaigns/${c.id}`} style={{ fontWeight: 600 }}>
                      {c.name}
                    </Link>
                  </td>
                  <td>{c.product_title ?? '—'}</td>
                  <td>
                    <span className={`badge badge-${c.status}`}>{c.status}</span>
                  </td>
                  <td className="num">{fmt.moneyShort(c.daily_budget_cents)}</td>
                  <td className="num">{fmt.moneyShort(c.spend_cents)}</td>
                  <td className="num">{fmt.moneyShort(c.revenue_cents)}</td>
                  <td className="num">
                    {c.spend_cents > 0 ? `${(c.revenue_cents / c.spend_cents).toFixed(2)}×` : '—'}
                  </td>
                  <td className="num">
                    {c.impressions > 0 ? `${((c.clicks / c.impressions) * 100).toFixed(2)}%` : '—'}
                  </td>
                  <td>
                    {c.status === 'active' ? (
                      <button className="btn btn-small" onClick={() => pause(c.id)}>
                        Pause
                      </button>
                    ) : (
                      <button className="btn btn-small btn-primary" onClick={() => resume(c.id)}>
                        Resume
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
